import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AccountsAPI } from "api/axios.config";

const BILL_REQUEST_BASE = "/BillRequest";
const JSON_HEADERS = { headers: { "Content-Type": "application/json" } };

const getBillRequestsList = (page, limit, query) =>
  AccountsAPI.get(
    `${BILL_REQUEST_BASE}?active=true&${query}&page=${page}&limit=${limit}`,
  );

const getBillingRequestDetails = (id) =>
  AccountsAPI.get(`${BILL_REQUEST_BASE}/${id}`);

const createBillingRequest = (data) =>
  AccountsAPI.post(BILL_REQUEST_BASE, JSON.stringify({ data }), JSON_HEADERS);

const updateBillingRequest = (id, data) =>
  AccountsAPI.patch(
    `${BILL_REQUEST_BASE}/${id}`,
    JSON.stringify({ data }),
    JSON_HEADERS,
  );

const deleteBillingRequest = (id) =>
  AccountsAPI.delete(`${BILL_REQUEST_BASE}/${id}`, {
    data: { data: { billRequestId: id } },
    ...JSON_HEADERS,
  });

const rejectBillingReqeust = (id, data) =>
  AccountsAPI.patch(
    `${BILL_REQUEST_BASE}/${id}/Reject`,
    JSON.stringify({ data }),
    JSON_HEADERS,
  );

const authorizeBills = (data) =>
  AccountsAPI.post(
    `${BILL_REQUEST_BASE}/Authorise`,
    JSON.stringify({ data }),
    JSON_HEADERS,
  );

const buildQuery = (parameter, sort) => {
  let query = "";
  if (parameter.billStatus != null && parameter.billStatus !== "") {
    query += `status=${encodeURIComponent(parameter.billStatus)}`;
  } else if (parameter.postingStatus === "true") {
    query += `Posted=true`;
  } else if (parameter.postingStatus === "false") {
    query += `Posted=false`;
  }
  if (parameter.fromDate) {
    query += `${query ? "&" : ""}fromDate=${parameter.fromDate}`;
  }
  if (parameter.toDate) {
    query += `${query ? "&" : ""}toDate=${parameter.toDate}`;
  }
  if (parameter.matterId) {
    query += `${query ? "&" : ""}MatterId=${parameter.matterId}`;
  }
  let orderby = "matterRef";
  if (sort?.field) {
    orderby = sort.dir === "desc" ? `${sort.field} desc` : sort.field;
  }
  query += `${query ? "&" : ""}orderby=${encodeURIComponent(orderby)}`;
  return query;
};

const fetchBillingRequestsList = createAsyncThunk(
  "billingRequests/fetchList",
  async ({ page, limit, parameter, sort }) => {
    const query = buildQuery(parameter, sort);
    const res = await getBillRequestsList(page, limit, query);
    return res.data;
  },
);

const initialState = {
  billRequestsList: undefined,
  isLoading: true,
};

const billingRequestsSlice = createSlice({
  name: "billingRequests",
  initialState,
  reducers: {
    clearBillingRequestsList: (state) => {
      state.billRequestsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillingRequestsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBillingRequestsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.billRequestsList = action.payload;
      })
      .addCase(fetchBillingRequestsList.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

const { clearBillingRequestsList } = billingRequestsSlice.actions;
const billingRequestsReducer = billingRequestsSlice.reducer;

export {
  billingRequestsReducer,
  fetchBillingRequestsList,
  clearBillingRequestsList,
  getBillingRequestDetails,
  createBillingRequest,
  updateBillingRequest,
  deleteBillingRequest,
  rejectBillingReqeust,
  authorizeBills,
};
